import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

import type { ValidOfferProps } from '../../acceptOffer/AcceptOffer.types';

export const DEALER_RATING_VARIATION_KEYS = {
  CONTROL: 'control',
  OFF: 'off',
  TEST: 'test',
};

export const DEALER_RATING_EVENT = (label: string) => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
  category: 'dealer_ratings',
  label,
  name: 'dealer_ratings_shown',
});

export const getIsReservePriceMet = ({
  offer,
  vehicleEnquiry,
}: {
  offer?: ValidOfferProps['offer'];
  vehicleEnquiry?: ValidOfferProps['vehicleEnquiry'];
}): boolean => {
  if (!offer || !vehicleEnquiry) {
    return false;
  }

  const { closingBid } = offer;
  const { value: closingBidValue } = closingBid ?? {};
  const { prepCosts, priceHigh, sellerWillAcceptPrice } = vehicleEnquiry ?? {};

  if (!priceHigh || !closingBidValue) {
    return false;
  }

  const reservePrice = sellerWillAcceptPrice ?? priceHigh - (prepCosts ?? 0);

  return closingBidValue >= reservePrice;
};
